export const ERROR_CODES = {
  FAILED: "FAILED",
  BAD_ARGUMENT: "BAD_ARGUMENT",
  NULL_VALUE: "NULL_VALUE",
  EXCEED_LENGTH: "EXCEED_LENGTH",
  SHORT_LENGTH: "SHORT_LENGTH",
  MALFORMED_VALUE: "MALFORMED_VALUE",
  ALREADY_EXIST: "ALREADY_EXIST",
  CODE_NOT_FOUND: "CODE_NOT_FOUND",
  ERROR_REQUEST_FOUND: "400",
  ERROR_REQUEST_UNAUTHORIZED: "401",
  ERROR_REQUEST_NETWORK_ISSUE: "0 Unknown Error",
  ERROR_REQUEST_IMAGE_UPLOAD: "-pic: 0 Unknown Error",
  CODE_EXPIRED: "CODE_EXPIRED",
  CODE_OLDER: "100CODE_OLDER9",
  CODE_VERIFIED_SUCCESS: "CODE_VERIFIED_SUCCESS",
  RESOURCE_NOT_FOUND: "RESOURCE_NOT_FOUND",
  LIMIT_EXCEED: "LIMIT_EXCEED",
  VALUE_MISS_MATCH: "VALUE_MISS_MATCH",
  CODE_VERIFY_LIMIT_EXCEED: "<CODE_VERIFY_LIMIT_EXCEED>",
  INVALID_SESSION: "Invalid session for the user",
  HOME_NOT_FOUND: "HOME_NOT_FOUND",
  USER_NOT_AUTHORIZED: "USER_NOT_AUTHORIZED",
  CAPTCHA_VERIFICATION_FAILED: "CAPTCHA_VERIFICATION_FAILED",
  USER_NOT_FOUND: "USER_NOT_FOUND",
  USER_NOT_CONFIRMED: "USER_NOT_CONFIRMED",
  DEVICE_NOT_FOUND: "DEVICE_NOT_FOUND",
  BODY_NOT_FOUND: "BODY_NOT_FOUND",
  DEVICE_IS_NOT_ACTIVATED: "DEVICE_IS_NOT_ACTIVATED",
  INVALID_EMAIL: "INVALID_EMAIL",
  TOKEN_NOT_FOUND: "TOKEN_NOT_FOUND",
  OKEN_INVALIDATED: "TOKEN_INVALIDATED",
  SITE_NOT_FOUND: "SITE_NOT_FOUND",
  PROVIDER_IS_GOOGLE: "PROVIDER_IS_GOOGLE",
  CODE_NOT_VERIFIED: "CODE_NOT_VERIFIED",
  BUILDING_NOT_FOUND: "BUILDING_NOT_FOUND",
  FLOOR_NOT_FOUND: "FLOOR_NOT_FOUND",
  REQUEST_SYNC_FAILED: "REQUEST_SYNC_FAILED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  QUERY_STRING_PARSE_FAILED: "QUERY_STRING_PARSE_FAILED",
  EMAIL_MISSING: "EMAIL_MISSING",
  LOCK_CERTIFICATE_NOT_VERIFIED: "LOCK_CERTIFICATE_NOT_VERIFIED",
  STATE_NOT_FOUND: "STATE_NOT_FOUND",
  INVALID_PARTNER_ID: "INVALID_PARTNER_ID",
  CERTIFICATE_NOT_FOUND: "CERTIFICATE_NOT_FOUND",
  INVALID_STATE: "INVALID_STATE",
  SITE_ID_NULL: "SITE_ID_NULL",
  FAILED_TO_UPDATE_SITE: "FAILED_TO_UPDATE_SITE",
  SITE_ALREADY_EXISTS: "SITE_ALREADY_EXISTS",
  BUILDING_ALREADY_EXISTS: "BUILDING_ALREADY_EXISTS",
  FLOOR_ALREADY_EXISTS: "FLOOR_ALREADY_EXISTS",
  UNIT_ALREADY_EXISTS: "UNIT_ALREADY_EXISTS",
  ACCESSPOINT_ALREADY_EXISTS: "ACCESS_POINT_ALREADY_EXISTS",
  INCORRECT_CURRENT_PASSWORD: "INCORRECT_CURRENT_PASSWORD",
  //JS Error Codes
  SyntaxError: "SyntaxError",
  EvalError: "EvalError",
  RangeError: "RangeError",
  ReferenceError: "ReferenceError",
  TypeError: "TypeError",
  URIError: "URIError",
  HTTP_ERROR_RESPONSE: "HttpErrorResponse",
  HTTP_FAILURE_RESPONSE: "Http failure response",
  UNIT_NOT_FOUND: "UNIT_NOT_FOUND",
  ACCESS_POINT_NOT_FOUND: "ACCESS_POINT_NOT_FOUND",
  BAD_REQUEST_EXCEPTION: "BadRequestException",
  ACCESSPOINT_NOT_FOUND: "ACCESSPOINT_NOT_FOUND",
  PHONE_NUMBER_ALREADY_EXISTS: "PHONE_NUMBER_ALREADY_EXISTS",
  USER_NOT_AVAILABLE: "user not found",
  DEVICEID: "deviceId",
  DEVICENAME: "deviceName",
  NOT_AUTHORIZED: "not authorized",
  ATTEMPT_LIMIT_EXCEEDED: "ATTEMPT_LIMIT_EXCEEDED",
  PARTNER_DEVICE_ALREADY_EXISTS: "Partner Device Already exists",
  USER_GROUP_ALREADY_EXISTS: "USER_GROUP_ALREADY_EXISTS",
  USER_ALREADY_EXISTS: "USER_ALREADY_EXISTS",
  CARDS_NOT_FOUND: "CARDS_NOT_FOUND",
  EVENT_NOT_FOUND: "EVENT_NOT_FOUND",
  INVALID_ACCESS_ID_WITH_GROUP: "INVALID_ACCESS_ID_WITH_GROUP",
  INVALID_ACCESS_TIME: "INVALID_ACCESS_WINDOW",
  UNIT_ACCESS_POINT_LIMIT_EXCEEDED: "UNIT_ACCESS_POINT_LIMIT_EXCEEDED",
  DEVICE_NAME_ALREADY_EXISTS: "DEVICE_NAME_ALREADY_EXISTS",
  UNABLE_TO_UPDATE_DEVICE_ON_PARTNER: "UNABLE_TO_UPDATE_DEVICE_ON_PARTNER",
  ACCESS_POINT_ALREADY_EXISTS: "Access Point with same name already exists",
  FLOOR_LIMIT_EXCEEDEDS: "FLOOR_LIMIT_EXCEEDEDS",
  DEVICE_ID_ALREADY_EXISTS: "DEVICE_ID_ALREADY_EXISTS",
  USER_TYPE_NOT_ALLOWED: "USER_TYPE_NOT_ALLOWED",
  ENTITIES_LIMIT_EXCEEDED: "ENTITIES_LIMIT_EXCEEDED",
};
